import React, { useEffect } from 'react';
import './Login.css'
import { Formik, Form, Field } from 'formik';
import { TextField, Checkbox, FormControlLabel, Button, CircularProgress, Switch } from '@mui/material';
import * as yup from 'yup';
import logoBrand from '../../assets/images/logo.png';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { fetchUserDetails, login, setToken } from '../../redux/authSlice'; // Make sure this path matches your file structure
import { useTranslation } from 'react-i18next';
import Cookies from "js-cookie";
import {toast} from 'react-hot-toast';
// Validation schema using yup
const LOGIN_FORM_SCHEMA = yup.object().shape({
    email: yup.string().email('Invalid email address').required('Email is required'),
    password: yup.string().required('Password is required'),
    // terms: yup.boolean().oneOf([true], 'You must accept the terms and conditions'),
});

const LoginForm = () => {

    useEffect(()=>{
        const userDetails =Cookies.get('userDetails');
        if (userDetails && JSON.parse(userDetails).data.token) {
          navigate("/active-orders");
        }
    },[])
    
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const navigate = useNavigate()
    const authStatus = useSelector((state) => state.auth.status);
    const authToken = useSelector((state) => state.auth.token);
    const authError = useSelector((state) => state.auth.error);
     const handleSubmitlogin = (values) => {
       dispatch(login({ email: values.email, password: values.password }))
         .then((response) => {
           if (response.payload && response.payload.token) {
             // Dispatch action to store the token in Redux store
             dispatch(setToken(response.payload.token));

             // Navigate to the dashboard or home page
             navigate("/active-orders");

            //  setSubmitting(false);
           } else {
            //  setSubmitting(false);
           }
         })
         .catch((error) => {
        //    toast.error(error);
        //    setSubmitting(false);
         });
     };
    // console.log("Auth", authToken)
    return (
        <>
            <div className="login-bg">
                <div className='container p-0'>
                    <div className="row d-flex justify-content-center align-items-center h-vh">
                        <div className="col col-xl-8">
                            <div className="card">
                                <div className="row g-0">
                                    <div className="col-md-7 col-lg-8">
                                        <div className="card-body p-4 p-lg-4 text-black">
                                            <h2 className="fprimary mb-3">{t('loginPage.login')}</h2>
                                            <Formik
                                                initialValues={{ email: '', password: '', terms: false }}
                                                validationSchema={LOGIN_FORM_SCHEMA}
                                                onSubmit={(values, { setSubmitting }) => {
                                                  
                                                    handleSubmitlogin(values)
                                                }}
                                            >
                                                {({ errors, touched, isSubmitting }) => (
                                                    <Form className="login-form">
                                                        <Field
                                                            as={TextField}
                                                            label={t('loginPage.email')}
                                                            name="email"
                                                            type="email"
                                                            fullWidth
                                                            className="mb-3"
                                                            error={touched.email && Boolean(errors.email)}
                                                            helperText={touched.email && errors.email}
                                                        />
                                                        <Field
                                                            as={TextField}
                                                            label={t('loginPage.password')}
                                                            name="password"
                                                            type="password"
                                                            fullWidth
                                                            className="mb-3"
                                                            error={touched.password && Boolean(errors.password)}
                                                            helperText={touched.password && errors.password}
                                                        />

                                                        <div className="d-flex justify-content-between">
                                                            <button type="submit" className="btn btn-primary greeen-btn lg-btn" variant="contained" disabled={isSubmitting || authStatus === 'loading'}>
                                                                {authStatus === 'loading' ? <CircularProgress size={24} /> : t('loginPage.login')}
                                                            </button>
                                                            {/* <button type="button" className="btn btn-light grey-btnx" variant="outlined" onClick={registerNewUser}>
                                                                {t('loginPage.registerNewuser')}
                                                            </button> */}
                                                        </div>
                                                        {/* <p className="disclaimer">
                                                            {t('loginPage.disclaimer')}
                                                        </p> */}
                                                    </Form>
                                                )}
                                            </Formik>
                                        </div>
                                    </div>
                                    <div className="col-md-5 col-lg-4">
                                        <div className="text-center d-flex align-items-center justify-content-center bg-box">
                                            <div className="cont-box">
                                                <img src={logoBrand} alt="GreenTrack™" className="img-fluid mb-3" />
                                                <p className="color-white font-16">Following Traditional</p>
                                                {/* <a href="" className="mt-3 color-white font-18"><strong>{t('loginPage.logoContentlink')}</strong></a> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

            </div>
        </>
    );
};
export default LoginForm
